import styled from 'styled-components';

export default styled.ul`
   padding-top: 3px;
   font-weight: 600;
   li {
      list-style-type: none;
      display: inline;
      &:not(:first-child):before {
         content: ' | ';
         color: ${({ theme }) => theme.primaryBlueLight};
         font-size: 1.1em;
      }
   }

   @media only screen and (max-width: 415px) {
      margin-left: auto;
   }
`;
